<template>
  <div
    class="property-listing property-1 card rounded-3"
    :class="border ? 'border' : 'border-0'"
  >
    <div class="listing-img-wrapper p-3">
      <div class="list-img-slide position-relative">
        <div class="position-absolute top-0 left-0 ms-3 mt-3 z-1">
          <div
            v-for="(tag, index) in item.tag"
            :key="index"
            class="label bg-success text-light d-inline-flex align-items-center justify-content-center me-1"
            :class="{
              'bg-success': tag === 'Verified',
              'bg-purple': tag === 'SuperAgent',
              'bg-danger': tag === 'New',
            }"
          >
            <img
              v-if="tag === 'Verified'"
              :src="verified"
              alt=""
              class="me-1"
            />
            <img v-if="tag === 'SuperAgent'" :src="user1" alt="" class="me-1" />
            <img v-if="tag === 'New'" :src="moon" alt="" class="me-1" />
            {{ tag }}
          </div>
        </div>
        <div
          v-if="item.propertyClosed"
          class="position-absolute ms-3 mt-3 z-1"
          style="
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            opacity: 70%;
          "
        >
          <div
            v-for="(tag, index) in item.tag"
            :key="index"
            class="label rentedclass bg-danger text-light d-inline-flex align-items-center justify-content-center me-1"
          >
            {{ item.tag2 === "For Rent" ? "Rented" : "Sold" }}
          </div>
        </div>
        <!-- 1. Add a ref to the slider element -->
        <div ref="sliderRef" class="rounded-3 overflow-hidden mb-0 slick-slider myIMG">
          <div  v-for="(el, index) in item.image" :key="index">
            <router-link :to="`/single-property-1/${item.id}`"
              ><img :src="el" class="img-fluid" alt="" aspect-ratio="1.7" cover
            /></router-link>
          </div>
           <div  v-if="item.image.length === 0">
            <router-link :to="`/single-property-1/${item.id}`"
              ><img :src="defaultImage" class="img-fluid" alt="" aspect-ratio="1.7" cover
            /></router-link>
          </div>
          
        </div>
      </div>
    </div>
    <div class="listing-caption-wrapper px-3">
      <div class="listing-detail-wrapper">
        <div class="listing-short-detail-wrap">
          <div class="listing-short-detail">
            <div class="d-flex align-items-center">
              <span
                v-if="item.tag2 === 'For Rent'"
                class="label bg-light-success text-success prt-type me-2"
                >For Rent</span
              >
              <span
                v-if="item.tag2 === 'For Sell'"
                class="label bg-light-danger text-danger prt-type me-2"
                >For Sell</span
              >
              <span class="label bg-light-purple text-purple property-cats">{{
                item.type
              }}</span>
            </div>
            <h4 class="listing-name fw-semibold fs-5 mb-2 mt-3">
              <router-link to="/single-property-1">{{ item.name }}</router-link>
            </h4>
            <div class="prt-location text-muted-2 d-flex align-items-center">
              <span class="svg-icon svg-icon-2hx"
                ><img :src="map" alt="" class="me-1" /></span
              >{{ item.loction }}
            </div>
          </div>
        </div>
      </div>
      <div class="price-features-wrapper">
        <div
          class="list-fx-features d-flex align-items-center justify-content-between"
        >
          <div
            class="listing-card d-flex align-items-center availability-highlight"
          >
            <div class="square--25 text-muted-2 fs-sm circle gray-simple">
              <i class="fa-solid fa-calendar-week fs-xs"></i>
            </div>
            <span class="text-primary fw-semibold me-1">Availability: </span>
            <span class="fw-semibold">{{ item.availableDate }}</span>
          </div>
          <div class="listing-card d-flex align-items-center">
            <div class="square--25 text-muted-2 fs-sm circle gray-simple me-1">
              <i class="fa-solid fa-bed fs-xs"></i>
            </div>
            <span class="text-muted-2 fs-sm">{{ item.beds }}</span>
          </div>
          <div class="listing-card d-flex align-items-center">
            <div class="square--25 text-muted-2 fs-sm circle gray-simple me-1">
              <i class="fa-solid fa-clone fs-xs"></i>
            </div>
            <span class="text-muted-2 fs-sm">{{ item.sqft }}</span>
          </div>
        </div>
      </div>
      <div
        class="listing-detail-footer d-flex align-items-center justify-content-between py-4"
      >
        <div class="listing-short-detail-flex">
          <h6 class="listing-card-info-price m-0">
            $ {{ item.propertyValue }}
          </h6>
        </div>
        <div class="footer-flex">
          <router-link
            :to="`/single-property-1/${item.id}`"
            class="btn btn-primary px-md-5 rounded"
          >
            View Property
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref, nextTick, onBeforeUnmount } from "vue";
import verified from "@/assets/img/svg/verified.svg";
import user1 from "@/assets/img/svg/user-1.svg";
import moon from "@/assets/img/svg/moon.svg";
// import send from "@/assets/img/svg/send.svg";
import map from "@/assets/img/svg/map-1.svg";
// import imagesLoaded from "imagesloaded";
import $ from "jquery";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import defaultImage from "@/assets/img/p-1.jpg";

defineProps({
  item: Object,
  height: String,
  border: Boolean,
});

const sliderRef = ref(null); // 2. Create the ref for the slider element

const initializeSlickSlider = () => {
  nextTick(() => {
    // 3. Use the specific ref as the selector, not the global class
    const slider = $(sliderRef.value); 
    
    try {
      if (slider.length > 0) {
        // The check for 'slick-initialized' is still good practice
        if (slider.hasClass("slick-initialized")) {
          slider.slick("unslick");
        }
        slider.slick({
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        });
      }
    } catch (error) {
      console.error("Error initializing Slick Slider:", error);
    }
  });
};

onMounted(() => {
  initializeSlickSlider();
});

// 4. Add a cleanup function to destroy the slider before the component is unmounted
onBeforeUnmount(() => {
  if (sliderRef.value && $(sliderRef.value).hasClass("slick-initialized")) {
    $(sliderRef.value).slick("unslick");
  }
});
</script>

<style scoped>
.availability-highlight {
  background: #eaf4fb;
  border-radius: 8px;
  color: #009868;
}
</style>
